import { IndicatorResult } from "../../types";

export function renderIndicatorLabel(indicator: IndicatorResult) {
	return `${indicator.name}${indicator.filters?.length ? ' (' + indicator.filters.join(',') + ')' : ''}`;
}
